module.exports = __webpack_public_path__ + "static/media/lightbag.e5f4e138.webp";